import {
  ProcurementPlanStateTypes,
  ProcurementPlanActionTypes,
} from "./ProcurementPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ProcurementPlanStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ProcurementPlanReducer = (
  state: ProcurementPlanStateTypes = INITIAL_STATE,
  action: any
): ProcurementPlanStateTypes => {
  switch (action.type) {
    case ProcurementPlanActionTypes.FETCH_ALL_PROCUREMENT_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProcurementPlanActionTypes.FETCH_ALL_PROCUREMENT_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProcurementPlanActionTypes.FETCH_ALL_PROCUREMENT_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProcurementPlanActionTypes.FETCH_ALL_PROCUREMENT_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ProcurementPlanActionTypes.FETCH_ONE_PROCUREMENT_PLAN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ProcurementPlanActionTypes.FETCH_ONE_PROCUREMENT_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProcurementPlanActionTypes.FETCH_ONE_PROCUREMENT_PLAN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ProcurementPlanActionTypes.FETCH_ONE_PROCUREMENT_PLAN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ProcurementPlanReducer;
